import { formatMoney } from './chunk-W5SU5LQ2.mjs';
import { DateTime } from 'luxon';

var lastOrdersTableFactory = (previousOrders, locations) => Object.values(previousOrders || {}).map((order) => {
  const locationId = order.locationId;
  const location = locations.find(
    (currentLocation) => currentLocation.id === locationId
  );
  return {
    id: order.orderId,
    createdAt: DateTime.fromISO(order.createdAt || "").toFormat(
      "MM/dd/yy hh:mm a"
    ),
    total: formatMoney(null, order.total),
    status: order.status,
    locationName: (location == null ? void 0 : location.name) || ""
  };
});

export { lastOrdersTableFactory };
